
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexRV0egwx5OCk4vR_455XGJk3uF14JDdC02XWgjditI85ZsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/index.vue?macro=true";
import { default as loginQoBM9e2y_45dVDukygIEVbAXP4rUnVUcN6EXmID9mLSE0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/login.vue?macro=true";
import { default as mgenAhxixgH_45T_8USODeH3svFfzwnrmpeizv_458uJTGreIu8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/mgen.vue?macro=true";
import { default as indexO1xIyLZNLuYIGFZVpPYfeZi_45Rln4OHg91X983SZojfIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/index.vue?macro=true";
import { default as notesM_45V2K2ebsMEXVYXLIKNoEUR6Co2EzTp2SKJ3KPlq1IYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/notes.vue?macro=true";
import { default as indexf7MK_2c7QQrVNqBJaeC1Om9iOeQnn0g2SJUT3OsJKIEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentjtV4NeNedJ7lOtgc48GeIuEmxksbywlX_45vWTtb_fgOUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45site1i70WWVP8uzbeQ_0HCqwzOKykbU3kX1jCf4kt4GDTkkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/plan-du-site.vue?macro=true";
import { default as editGREDNoie2Ld2S6j5QmR1P1OIZH8N7kRpIcvEcxYXlEcMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/edit.vue?macro=true";
import { default as placesNexxWlrzB1S6BhmcD5M3Jt8eHMJl3HoYuNAXCM7UFvwMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/places.vue?macro=true";
import { default as accessibilitea4hm73k6d8GIen5IohIuwqfoTbkLL3RdnS_qyO85LUEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/accessibilite.vue?macro=true";
import { default as _91id_93yLRARAN3GQznV3s9EwIZSNANwlrJ_39oLp_45R3OwhKQAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/[id].vue?macro=true";
import { default as notificationsmRJ7kuTpxaBXQO3pajsCCr2Z3rbAuVKZL7x8K3kYyz8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/notifications.vue?macro=true";
import { default as indexD_45q_45lvmZtwv8S2MrcqlxlAS6_45qWJ6RTf2tPB4n6RoZUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/index.vue?macro=true";
import { default as indexm35Z8TUKFSvz_45G_RoTiiZSa9tarMo6EJi4J3VFKyB9cMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/index.vue?macro=true";
import { default as _91slug_935KOp70kCy5GYnZitRSUFUJdHjv4yuCOKidIH5FzSBBMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/villes/[slug].vue?macro=true";
import { default as indexVVpkYBeYfyNFD5prpKm8RUKJJRzJN6DOguNL7YyvP90Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/index.vue?macro=true";
import { default as generiqueIpMeV3RGYpNvjhA5BS8rwIlh3QZIVNfvJnfFpdVjhV4Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93Kka5Bulsndo6ov5BPgA8fOcoaZbMCdOycVPFVkndhAIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/reseaux/[slug].vue?macro=true";
import { default as missionsm7J3uHEC0B9GAEH5v9wCkQiIpu9YQtR9yvJgKcHoIyEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/missions.vue?macro=true";
import { default as indexTOBu6_uw9YR9QBiUkUP0W1EWbLgCLR316B25_dZPfnAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/dashboard/index.vue?macro=true";
import { default as favorisBz5AkxGErvAaFG0Xj8T_45Ns1fYphUmBEuSPI_45nPlAKTkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93D_A_xkkDSpJuW5m7MKkVgEmYSVeIMpMprqxlQQq078kMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/activites/[slug].vue?macro=true";
import { default as logs9aZRmYaxfUUOOSe_xyaVPDFmFihWbQuDCoM4SK8JYBsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesFpN5dQTCWK3jtPRZSCOnS5sxvhgiQ9hOfWCA73aUI3IMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalessdYyLhQxUQY0d8MQ4CPdWO_45mAWdPgiC_HJnRA5QUFYcMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/mentions-legales.vue?macro=true";
import { default as missionsYZ7KntFhFFgiJoJElJpFWYu5R06Au1gepKl4V2JhOccMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/missions.vue?macro=true";
import { default as settingsQmzB1NoM8_45mwI4OCvaSMh6jvRSJ8_45vEjNxnIfEfPXN8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/settings.vue?macro=true";
import { default as tournee_45etel2O_45Ol5JAH_45i5qwODcZna5weqbAfbOpd1t3oReM6DKQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesV3765KoYUbKOO3JSwWF7AckphU5n4Gbl96EveBfJzxUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/temoignages.vue?macro=true";
import { default as index0gG3oEl5Ww5R_45p_mbhHDGGckwymfhL4_wNc4Qo8CSCYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/index.vue?macro=true";
import { default as adminyTISl2RICXR8E6C5ztz9_45ojcgduynIyj2chINjydzRQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/maintenance/admin.vue?macro=true";
import { default as indexoP0YsESouTTg3XdtShIpEqrF7KY_45UIiekLJmxT2yvqUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/maintenance/index.vue?macro=true";
import { default as indexQhCnUtSH6XYDIv61sXyuFHLIDbJtpEiD3FIqgnDEMocMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/territoires/index.vue?macro=true";
import { default as _91hash_93qbA6i8r0A28SHYylKtr_45_CGGUPVNyQVBTUKXkEJK7bAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursTfh3bYyuZLlGvcysNTL1s691mKj_4590hpXbprU4TBx2kMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93qQL72FYhL3vhxY2ZXwk6f_rUrUHzWRwQklKtyl6A_45lUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93uOH3JSuU2YsPHh_uSa9e_4yEQ80JCBngRks_45SdhHIxMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/departements/[slug].vue?macro=true";
import { default as indexQXspP_455xJbftTclyxV0IVmdCUaK0O1xctnIgjJL_0RUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/organisations/index.vue?macro=true";
import { default as preferencesIcZWH1G6S8DAiQNvBfJxC_XdSNXo36dmsRGsCHuAIHoMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/preferences.vue?macro=true";
import { default as organisations8LZj8oD82nZORktnAZhlSlqDCTy6On5wHvt3DjIwIt8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/organisations.vue?macro=true";
import { default as _91token_93GcuaP4BB1GKkjrRrixaILp82ERHwz1ng3GDzxJbftFIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/temoignages/[token].vue?macro=true";
import { default as postst_456wzCN1gaawS1KvK66Yd6YA_45GXU8UF9qGLsZhf0LU8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/posts.vue?macro=true";
import { default as indexNF4fZS4mB1V0wyusjgxCgM4jpLuuhCvvVLhy672QTxgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/index.vue?macro=true";
import { default as addSTNvqYKiWzF0WAMCgCcA2206DknQ3hfD_OxrzsP_FBEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93ls_d1SRK9kO9Ct8HgyTdMMfzgDT5RgIsfkUN5I1QDLUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/organisations/[slug].vue?macro=true";
import { default as indexTsZc5n8MqFU447NCLv4t931vn5rqTwbVYSRqvNvjfekMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/password-reset/index.vue?macro=true";
import { default as participationskbn1voh2khsY1_45olaHt5gEQ6mpavqQo3LzjNN1QgyHMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/participations.vue?macro=true";
import { default as emailsKDBPGHjC3_45EcfXBbiGMqbQE1ZAXjq73dWvIzo1I5kGoMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/emails.vue?macro=true";
import { default as indexT8Fxr4QbcJgarxRQ9mu_45kRECdw3sWTr6zobK8v3dU54Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/alertes/index.vue?macro=true";
import { default as notificationslI_oaZ8NvBrxbyDzgC69HZ8AdutTYDb7iJiGFBTh0GkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/notifications.vue?macro=true";
import { default as indexvJ3WThOEj6EmTIXN0EYJAxB4uuCbblRv_52t74wh40EMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueD5MuSsFztOGDopEga_9Ck5I8tKKhnnXnW2SdGnYmZ2UMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_9397wLuV_HwmXsr22xFzO3NwxZ6h10_NUDiKd6L2xKm_45EMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/domaines-action/[slug].vue?macro=true";
import { default as index92WnHrKcHKY_dBxizG_sPnlNzI_Ywf15CN5HuBhUSgcMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93_5kyMcy5h4wSxNk23qAP1SluCmVphx3Ui130x70HzKUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleq_4586V0d3Yq_45td4TKg1lP1s8vkMKRoZ6Wc_45QIyLOC_7oMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsDyV_l_YtJzFlDullBr3LOHvQYb71M_8oHXVLoeuP9gYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/other/invitations.vue?macro=true";
import { default as messages_45FzmFxu3GxBXECjsU0_45qinoWSuVXz7IBWkabqYdOo5wMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/messages.vue?macro=true";
import { default as placeszPFdkIvxDgPNYKJKN7oXQ2WTjnYWQ5V1BBzNzPimBtUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/places.vue?macro=true";
import { default as addgRBuxE1bFeIY5RRpwjetFuOtDSaxsxYGLbmhuNO4ff8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexwDo6Xjk2j123Mr7UGRSF3GsCRuEsPWmHck8SSTHli70Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexr6_45MdT_TbrX5KWoa8g1LCgjd2pPAw0XL8cKAiUltPHwMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/missions-benevolat/index.vue?macro=true";
import { default as dates_45QDUjZmV1WlHy6xErZOIlrlufTHGJ29UA401M2OerBkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexl0aRyi5NNWDkVrpqaQHX5K4B5X_JGyPMnc7pAa5hBhsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxTSOJ0QCXE1qmDJ16rcKgrrWFfVrTg22e5_45Yfw0_OfdgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleoebft0BUwLxFid5dBZDekkXNsGpGYpeTYBjfpPcLUBAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexO1hZmvkkZd29MujNf1UDRTR5ZWmhd29g1PSsxe8OIWgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/index.vue?macro=true";
import { default as missions39kRbgTdjwfwH2MgqEGGE7SPaHbJSh_45tI6YcGRtjUnsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/missions.vue?macro=true";
import { default as addUZs4dXWcQJ7rdgGS3_45JUxKJM5k7n8pcnrAuT6iv4ZNEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelq9K28WD8WtllEekkyPGMoLv0gHm8L8SSK0BBffK3QsIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexXknNJcP7rfinGJZ73qyxyfuPNJjIMb1B6Fu_45IHHnThIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/participations/index.vue?macro=true";
import { default as index8O7y1zcbg4_45cUP14VEvTdjhU4FS8vN3sRperdFdIG58Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexsFMH_45tb_45qT7nZbgvmPj2OVMV26H9_aoEmEEyD_452Z9CkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/index.vue?macro=true";
import { default as addySeprOdr75_45sqLwy_KzMgDiqNQi2utEOW8NnFHY7H7gMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as adduWlPk_I2DQs9_45ca8m2R1JoMBXShQEockfRIiPB2GRFMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addiJACr6lIb47bMjw6FKBNYzDKKfe1xKC7mmxFfuNIp6IMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexwwmLSOivBqdqJNI1JXn0bRTiOB_45bTXR68DgpSn8UvrwMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsu9p3OvrQ_a7nJpaQtoi8ZvKOlRx4hNyJnYc_T_vFngEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/conversions.vue?macro=true";
import { default as editGT4PHDrxWRkiqCHdeschNtIzG0YSR_45xkcSd9RqaVKP0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteVSFcxriPO_4586mYKdoW_45O_sgxbbN3omaqmyOq90_45w3iMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/politique-de-confidentialite.vue?macro=true";
import { default as indextp0t1NcNUwniYVugOddOL6zBf2tEuAHCKvXD_fsTyqYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addlyziFWqusJjXNeDom8dHCwRcipJhg7Qi_45eOgcwujxmQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesF4zOzp9_45NO121JbpY3pjq7rYHKwUYC8SC90vfaAyZqkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editQO0dNDU2KETDa4V5XKIO78NTmDmSAFsjGVbinAZfHiUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursHZfu1fQD2UZef6_xVepQgKRk6fYvtAcEQG6g1yMWlYoMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexWmK495tAwfDrZiyOp9xlcJdJsDBUL3mkFlM7f08mSoUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexcWNhUTLju8uR9M_dB4e0xQ8g208RnLyMq3EcNGvqRDoMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexk3pSb8eVdbEGFoBZTP7OJKHnPm1PbP9RIgdbb1UYgv4Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/index.vue?macro=true";
import { default as indexarJkxPslLKGiJ7qw_s1NTXsiK1W4m5RIHrjhXg_NsYYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrerq4cKSjp_Lt7blnCt8pVFF1OMNvf11EiXhIp10ZnxXsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as index5Lnm7FPzJTM8PpTQU3818BLBROAxSlaTzRLi7wqn4LcMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addGU5UNouWQN386zxTrijKlujpSkqCT_45IuCa8kC_u2Am0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexkzjj0WKDBoO_1Esq1dkoc9QcydzMCjbyBv4V16iFeMAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editVEbwKwMwqLLErhpJmuSD3KWSiKpdfLmwnBIiWeuOr2UMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93k0snPZrP9yTVjPPC2nQ5NQafLfw6arKndfbufWlwQxEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteqRC1u5WwtwugCgsZuf05taZM6jhxHAcxYewQ_dhGpoMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexzUdw7I4QsuEwHphlYI9FORtIOPjtrYh1Ba583QUPTXQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsQNbhdCmeE4GggebBhf_45Qm1zgSql0YP89sgEaknGxY0MMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/participations.vue?macro=true";
import { default as indexMVEUXjpQnw5RC8Lrp_4527cb7B_2JNJgtLAqJI1MBfQT0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logslJUbJOMJ_jUgtuNPGXJi8Ilfk1JbGWr_45_y9St_45E3cOcMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/referents/activity-logs.vue?macro=true";
import { default as editlBLVX1PSoFmnJ4bGzo5eLluMp5jWXtNVt7dxUnvmb84Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexhLy422uf_45MfjUQNDdJaMHVO9UkoKa_gccBCh9mT7IbYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informations9e9u2aFzvce6rFDwjJ73sWEDeTY3IkEDpTndBWqC_455EMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesRvPZrOIwaly_45mT35vG7wtwspwURswr7jeuNBjidj5IgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editHwjXWyJZEphI1U5hvjBNpiRSIE7s3_45cyC5h21eqveO8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexRxsP2TqwH4C_qVBfZy2Gf5gLFTlW_Mdd5UR8t9bg3SwMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexjc8Z_453QuBzhoY8_45yfsRfHbw9_45XusWrXsr_3PNUm5YEQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesGaWOK7eJQMm8Oe2qd5eeGogz1HGnqBAFaR4GTbSgUpMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editgu_45hCXym_ntk17K4SQa7ScnqlRECz1FSVHIhHrVJezYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profile9cicm4Y1Ie10jCf5IK3xRd5O2bSWRFqDONjjW2dJi4UMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementnf1pFKHj_kXMLxZx2yVhZy7EB8WOBfG8UiN5se7IZCkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsCjvruv_weMTqr0kKeExZMXOuK7iVKZ7rvM0eLJqZTcwMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editJsP9_45_gWw0QtaxeQ7XlbuJeOMiHtXQJZ4SpBY7NGojQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addWtiBRT7PEsnqFPC1DmAxmyyHU2J3u5xZTd_45dINwPlwAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationrxWYQqtt0ygDAeeDXcpkEplJ91xOIkx2nfQj8J0pFSgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexg8wDGHmAD0V3bftQd0_o2aiS3saBIcaUQ7q9_456FM_ZAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editL15iCWgfd0gNLpp1Ozfl54hu6k8u2yC_xQiPrbu_B_EMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsUXh_x5bB8N8ybmY3w1O_45qdsgATLeyPFksQLogaPC1isMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsaa4kf2GWe4bWTNukZ2cW6pZzge4OQE6n0d90YL_22z0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevoles_G6dAJs2B584h74p54l_mhuYQFAs5_wHnjHfzzpKMUIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingYXY9d2U1WaEiV6wBBJU0vv9_45Z7lzXLwZuTEj2iGxZS0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexAFbxvZCjpuYariyopqpX1h74SPVgs1zoF6LAXLF6i4IMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editcw4C8hQVEoy2Bwvr3LY6eO7Mpx5m2pfZP758mInnPNsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexObwkz9PaNkZEzNEriJC49g0JubxmQr5714QVslpL1PMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileSu0G7BDGxZgdg8DiYPD8DQGT9X_l006BMKIXLwW2vHQMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexxPMIGPq3gPhlmXLvdRCZA4WgRpTd0jLDLxw6VmSllkgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editZV43f_451dEoSj0b0bNxhszvpRmUAHBmAdNHWVG7qqerEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addNz803sdR6_453Q_45IOxt3EoQE380YXrzBX0gwHVTSFa5C8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesenH_23d1btwPLLbp_45dZpahctIgURRf7cu8GafAJ_45eacMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesXU6nyyza5qO9lyCG3JoCHr3Ktd8XCAjizA_45JxJgMeG8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45users3ylG27Te1JoBOk4tOPXXMV_45hK8hnNuUgyfIOifh2OHwMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresnnlA1KK6aLWYHMAIetK2tYQzwk3vV7asLG94bjdRd_45MMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsableszMM0SROhIa4_45JgOapyGAWSCcK_45K3Q7JoPM_45thz3phpEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisation9SNKWYQLqtd52NRSpsDZZKbgMp29RhkRQ_eNpKDgMZsMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedhxo6eBmKweJ_45vFrpc_LFSqbtQckGyng7Ge5GS4H8CW8Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsZBOzFVFnFKAYePIgJjhU6_45IuWzUlQRekSuo9IVJ9E7UMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45roleUYZG12nERAJK0f7KhKorV_45c5rb91nBUqr9FxkCsiafIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationssvloe3BsoE5XSacxgB8BF2ynJRDcJrmndiTVqt_45eLWEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editMza2DM69Oif4OkzkOyEcEbzIPaZlwiWtrGIm_45NL0bEYMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesPCf4CVNrOe61s_yBxqvOkQWDO8uNQGLx6zW_0EUP8jgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkAjTj32v0fJtFrwctNbawDX4IcNA_45qj_45Z4xNPpW4a57MMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexQFlUEer5HuK34afZOQw_5iAyDaFrFo84rC4OTdMvYBAMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteNtYF1NdAmFtW8viAE3IKliF0V0drtKGa2HloRTzj0roMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationgd2QRqLiSjFAElYkHCaZS14WxAdFnbWSZ6AVGmQStm4Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationslE8N4_45XLIYYQctdGI0AsasUqVW_45TKtAKuRVpYnT4fKgMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrant91JMIpnhnrARZWgB8MYUy4w0lcCWEFzmrgicvvfOl_458Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantHwOjmfQbNoD1F76jYyXP1hsJC3gFtpNQvL976Y5QnJIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as index0Z2aDAdUfuFUEsW81a4BQkTwTfzyew6dCHdh4Rn6G_kMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesQkoZC8om2yUcgjQH6r03V7KX86ZSL_zn9g_45i68wpfHUMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerf7AoyaBanhvGMZdfrU1QQ4G44SCCS96_d6Op19LOHcIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesFJdA64aMWaIuokix_454at8hRxSVRBQ0L_454mlkKxi3qXkMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesP4P__Kitd6rJVPTr5Qp6V7CNg48D01P27o9_0O_45UmhMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsj5yk1emoh7KaLFPw53y95uNZoGgZ9CjGTmrIVjmaBjMMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedbrDUrKDjvijKZy9a_rs4UXt9ryvU9PePb8aVNzTrUNEMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectdhEmxivkeEaNwJFFGQNjWjbzPGEAz8o0oMjWpHuKIJoMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerwaK_vNkM9biPphHlk_pZ4nLFxj_Ad84PJOnzmx0OmX4Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementeqcEoID0gVNpdiLNEHEVvMaSOGO2qqkHsr49UI66B1AMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationStQNnw3qSbzgmoT1JrzJR65pWZWAPkjchnf4v3CsxrcMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationqsv_FiBOeDEFBuAZWSs0ieEpIADWCZcgPR38WJMLqA4Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerMKuDFJ6iNipBDIL8oq2tMXGyipP4q5CwMWE976SbZCIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesnyEXdxx7xHAE9_45dyfgqPZiubAIvfU5NX7951iTuoZe0Meta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI } from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginQoBM9e2y_45dVDukygIEVbAXP4rUnVUcN6EXmID9mLSE0Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenAhxixgH_45T_8USODeH3svFfzwnrmpeizv_458uJTGreIu8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexO1xIyLZNLuYIGFZVpPYfeZi_45Rln4OHg91X983SZojfIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesM_45V2K2ebsMEXVYXLIKNoEUR6Co2EzTp2SKJ3KPlq1IYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexf7MK_2c7QQrVNqBJaeC1Om9iOeQnn0g2SJUT3OsJKIEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editGREDNoie2Ld2S6j5QmR1P1OIZH8N7kRpIcvEcxYXlEcMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesNexxWlrzB1S6BhmcD5M3Jt8eHMJl3HoYuNAXCM7UFvwMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93yLRARAN3GQznV3s9EwIZSNANwlrJ_39oLp_45R3OwhKQAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsmRJ7kuTpxaBXQO3pajsCCr2Z3rbAuVKZL7x8K3kYyz8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexD_45q_45lvmZtwv8S2MrcqlxlAS6_45qWJ6RTf2tPB4n6RoZUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexm35Z8TUKFSvz_45G_RoTiiZSa9tarMo6EJi4J3VFKyB9cMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexVVpkYBeYfyNFD5prpKm8RUKJJRzJN6DOguNL7YyvP90Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueIpMeV3RGYpNvjhA5BS8rwIlh3QZIVNfvJnfFpdVjhV4Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93Kka5Bulsndo6ov5BPgA8fOcoaZbMCdOycVPFVkndhAIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsm7J3uHEC0B9GAEH5v9wCkQiIpu9YQtR9yvJgKcHoIyEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexTOBu6_uw9YR9QBiUkUP0W1EWbLgCLR316B25_dZPfnAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisBz5AkxGErvAaFG0Xj8T_45Ns1fYphUmBEuSPI_45nPlAKTkMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logs9aZRmYaxfUUOOSe_xyaVPDFmFihWbQuDCoM4SK8JYBsMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsYZ7KntFhFFgiJoJElJpFWYu5R06Au1gepKl4V2JhOccMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsQmzB1NoM8_45mwI4OCvaSMh6jvRSJ8_45vEjNxnIfEfPXN8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45etel2O_45Ol5JAH_45i5qwODcZna5weqbAfbOpd1t3oReM6DKQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: index0gG3oEl5Ww5R_45p_mbhHDGGckwymfhL4_wNc4Qo8CSCYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminyTISl2RICXR8E6C5ztz9_45ojcgduynIyj2chINjydzRQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexoP0YsESouTTg3XdtShIpEqrF7KY_45UIiekLJmxT2yvqUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93qbA6i8r0A28SHYylKtr_45_CGGUPVNyQVBTUKXkEJK7bAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursTfh3bYyuZLlGvcysNTL1s691mKj_4590hpXbprU4TBx2kMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesIcZWH1G6S8DAiQNvBfJxC_XdSNXo36dmsRGsCHuAIHoMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisations8LZj8oD82nZORktnAZhlSlqDCTy6On5wHvt3DjIwIt8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93GcuaP4BB1GKkjrRrixaILp82ERHwz1ng3GDzxJbftFIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postst_456wzCN1gaawS1KvK66Yd6YA_45GXU8UF9qGLsZhf0LU8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexNF4fZS4mB1V0wyusjgxCgM4jpLuuhCvvVLhy672QTxgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addSTNvqYKiWzF0WAMCgCcA2206DknQ3hfD_OxrzsP_FBEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93ls_d1SRK9kO9Ct8HgyTdMMfzgDT5RgIsfkUN5I1QDLUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexTsZc5n8MqFU447NCLv4t931vn5rqTwbVYSRqvNvjfekMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationskbn1voh2khsY1_45olaHt5gEQ6mpavqQo3LzjNN1QgyHMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsKDBPGHjC3_45EcfXBbiGMqbQE1ZAXjq73dWvIzo1I5kGoMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexT8Fxr4QbcJgarxRQ9mu_45kRECdw3sWTr6zobK8v3dU54Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationslI_oaZ8NvBrxbyDzgC69HZ8AdutTYDb7iJiGFBTh0GkMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexvJ3WThOEj6EmTIXN0EYJAxB4uuCbblRv_52t74wh40EMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: index92WnHrKcHKY_dBxizG_sPnlNzI_Ywf15CN5HuBhUSgcMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93_5kyMcy5h4wSxNk23qAP1SluCmVphx3Ui130x70HzKUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleq_4586V0d3Yq_45td4TKg1lP1s8vkMKRoZ6Wc_45QIyLOC_7oMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsDyV_l_YtJzFlDullBr3LOHvQYb71M_8oHXVLoeuP9gYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messages_45FzmFxu3GxBXECjsU0_45qinoWSuVXz7IBWkabqYdOo5wMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placeszPFdkIvxDgPNYKJKN7oXQ2WTjnYWQ5V1BBzNzPimBtUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addgRBuxE1bFeIY5RRpwjetFuOtDSaxsxYGLbmhuNO4ff8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexwDo6Xjk2j123Mr7UGRSF3GsCRuEsPWmHck8SSTHli70Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexr6_45MdT_TbrX5KWoa8g1LCgjd2pPAw0XL8cKAiUltPHwMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: dates_45QDUjZmV1WlHy6xErZOIlrlufTHGJ29UA401M2OerBkMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexl0aRyi5NNWDkVrpqaQHX5K4B5X_JGyPMnc7pAa5hBhsMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxTSOJ0QCXE1qmDJ16rcKgrrWFfVrTg22e5_45Yfw0_OfdgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleoebft0BUwLxFid5dBZDekkXNsGpGYpeTYBjfpPcLUBAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexO1hZmvkkZd29MujNf1UDRTR5ZWmhd29g1PSsxe8OIWgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missions39kRbgTdjwfwH2MgqEGGE7SPaHbJSh_45tI6YcGRtjUnsMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addUZs4dXWcQJ7rdgGS3_45JUxKJM5k7n8pcnrAuT6iv4ZNEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelq9K28WD8WtllEekkyPGMoLv0gHm8L8SSK0BBffK3QsIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexXknNJcP7rfinGJZ73qyxyfuPNJjIMb1B6Fu_45IHHnThIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: index8O7y1zcbg4_45cUP14VEvTdjhU4FS8vN3sRperdFdIG58Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexsFMH_45tb_45qT7nZbgvmPj2OVMV26H9_aoEmEEyD_452Z9CkMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addySeprOdr75_45sqLwy_KzMgDiqNQi2utEOW8NnFHY7H7gMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: adduWlPk_I2DQs9_45ca8m2R1JoMBXShQEockfRIiPB2GRFMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addiJACr6lIb47bMjw6FKBNYzDKKfe1xKC7mmxFfuNIp6IMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexwwmLSOivBqdqJNI1JXn0bRTiOB_45bTXR68DgpSn8UvrwMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsu9p3OvrQ_a7nJpaQtoi8ZvKOlRx4hNyJnYc_T_vFngEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editGT4PHDrxWRkiqCHdeschNtIzG0YSR_45xkcSd9RqaVKP0Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indextp0t1NcNUwniYVugOddOL6zBf2tEuAHCKvXD_fsTyqYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addlyziFWqusJjXNeDom8dHCwRcipJhg7Qi_45eOgcwujxmQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesF4zOzp9_45NO121JbpY3pjq7rYHKwUYC8SC90vfaAyZqkMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editQO0dNDU2KETDa4V5XKIO78NTmDmSAFsjGVbinAZfHiUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursHZfu1fQD2UZef6_xVepQgKRk6fYvtAcEQG6g1yMWlYoMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexWmK495tAwfDrZiyOp9xlcJdJsDBUL3mkFlM7f08mSoUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexcWNhUTLju8uR9M_dB4e0xQ8g208RnLyMq3EcNGvqRDoMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrerq4cKSjp_Lt7blnCt8pVFF1OMNvf11EiXhIp10ZnxXsMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: index5Lnm7FPzJTM8PpTQU3818BLBROAxSlaTzRLi7wqn4LcMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addGU5UNouWQN386zxTrijKlujpSkqCT_45IuCa8kC_u2Am0Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexkzjj0WKDBoO_1Esq1dkoc9QcydzMCjbyBv4V16iFeMAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editVEbwKwMwqLLErhpJmuSD3KWSiKpdfLmwnBIiWeuOr2UMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteqRC1u5WwtwugCgsZuf05taZM6jhxHAcxYewQ_dhGpoMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexzUdw7I4QsuEwHphlYI9FORtIOPjtrYh1Ba583QUPTXQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsQNbhdCmeE4GggebBhf_45Qm1zgSql0YP89sgEaknGxY0MMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logslJUbJOMJ_jUgtuNPGXJi8Ilfk1JbGWr_45_y9St_45E3cOcMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editlBLVX1PSoFmnJ4bGzo5eLluMp5jWXtNVt7dxUnvmb84Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexhLy422uf_45MfjUQNDdJaMHVO9UkoKa_gccBCh9mT7IbYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informations9e9u2aFzvce6rFDwjJ73sWEDeTY3IkEDpTndBWqC_455EMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesRvPZrOIwaly_45mT35vG7wtwspwURswr7jeuNBjidj5IgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editHwjXWyJZEphI1U5hvjBNpiRSIE7s3_45cyC5h21eqveO8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexRxsP2TqwH4C_qVBfZy2Gf5gLFTlW_Mdd5UR8t9bg3SwMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexjc8Z_453QuBzhoY8_45yfsRfHbw9_45XusWrXsr_3PNUm5YEQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesGaWOK7eJQMm8Oe2qd5eeGogz1HGnqBAFaR4GTbSgUpMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editgu_45hCXym_ntk17K4SQa7ScnqlRECz1FSVHIhHrVJezYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profile9cicm4Y1Ie10jCf5IK3xRd5O2bSWRFqDONjjW2dJi4UMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsCjvruv_weMTqr0kKeExZMXOuK7iVKZ7rvM0eLJqZTcwMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editJsP9_45_gWw0QtaxeQ7XlbuJeOMiHtXQJZ4SpBY7NGojQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addWtiBRT7PEsnqFPC1DmAxmyyHU2J3u5xZTd_45dINwPlwAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexg8wDGHmAD0V3bftQd0_o2aiS3saBIcaUQ7q9_456FM_ZAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editL15iCWgfd0gNLpp1Ozfl54hu6k8u2yC_xQiPrbu_B_EMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsUXh_x5bB8N8ybmY3w1O_45qdsgATLeyPFksQLogaPC1isMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsaa4kf2GWe4bWTNukZ2cW6pZzge4OQE6n0d90YL_22z0Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingYXY9d2U1WaEiV6wBBJU0vv9_45Z7lzXLwZuTEj2iGxZS0Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexAFbxvZCjpuYariyopqpX1h74SPVgs1zoF6LAXLF6i4IMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editcw4C8hQVEoy2Bwvr3LY6eO7Mpx5m2pfZP758mInnPNsMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexObwkz9PaNkZEzNEriJC49g0JubxmQr5714QVslpL1PMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileSu0G7BDGxZgdg8DiYPD8DQGT9X_l006BMKIXLwW2vHQMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexxPMIGPq3gPhlmXLvdRCZA4WgRpTd0jLDLxw6VmSllkgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editZV43f_451dEoSj0b0bNxhszvpRmUAHBmAdNHWVG7qqerEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addNz803sdR6_453Q_45IOxt3EoQE380YXrzBX0gwHVTSFa5C8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesenH_23d1btwPLLbp_45dZpahctIgURRf7cu8GafAJ_45eacMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesXU6nyyza5qO9lyCG3JoCHr3Ktd8XCAjizA_45JxJgMeG8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45users3ylG27Te1JoBOk4tOPXXMV_45hK8hnNuUgyfIOifh2OHwMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresnnlA1KK6aLWYHMAIetK2tYQzwk3vV7asLG94bjdRd_45MMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisation9SNKWYQLqtd52NRSpsDZZKbgMp29RhkRQ_eNpKDgMZsMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedhxo6eBmKweJ_45vFrpc_LFSqbtQckGyng7Ge5GS4H8CW8Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsZBOzFVFnFKAYePIgJjhU6_45IuWzUlQRekSuo9IVJ9E7UMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45roleUYZG12nERAJK0f7KhKorV_45c5rb91nBUqr9FxkCsiafIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationssvloe3BsoE5XSacxgB8BF2ynJRDcJrmndiTVqt_45eLWEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editMza2DM69Oif4OkzkOyEcEbzIPaZlwiWtrGIm_45NL0bEYMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesPCf4CVNrOe61s_yBxqvOkQWDO8uNQGLx6zW_0EUP8jgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkAjTj32v0fJtFrwctNbawDX4IcNA_45qj_45Z4xNPpW4a57MMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexQFlUEer5HuK34afZOQw_5iAyDaFrFo84rC4OTdMvYBAMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteNtYF1NdAmFtW8viAE3IKliF0V0drtKGa2HloRTzj0roMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationgd2QRqLiSjFAElYkHCaZS14WxAdFnbWSZ6AVGmQStm4Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationslE8N4_45XLIYYQctdGI0AsasUqVW_45TKtAKuRVpYnT4fKgMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrant91JMIpnhnrARZWgB8MYUy4w0lcCWEFzmrgicvvfOl_458Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantHwOjmfQbNoD1F76jYyXP1hsJC3gFtpNQvL976Y5QnJIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: index0Z2aDAdUfuFUEsW81a4BQkTwTfzyew6dCHdh4Rn6G_kMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesQkoZC8om2yUcgjQH6r03V7KX86ZSL_zn9g_45i68wpfHUMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerf7AoyaBanhvGMZdfrU1QQ4G44SCCS96_d6Op19LOHcIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesFJdA64aMWaIuokix_454at8hRxSVRBQ0L_454mlkKxi3qXkMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesP4P__Kitd6rJVPTr5Qp6V7CNg48D01P27o9_0O_45UmhMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsj5yk1emoh7KaLFPw53y95uNZoGgZ9CjGTmrIVjmaBjMMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedbrDUrKDjvijKZy9a_rs4UXt9ryvU9PePb8aVNzTrUNEMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerwaK_vNkM9biPphHlk_pZ4nLFxj_Ad84PJOnzmx0OmX4Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationStQNnw3qSbzgmoT1JrzJR65pWZWAPkjchnf4v3CsxrcMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationqsv_FiBOeDEFBuAZWSs0ieEpIADWCZcgPR38WJMLqA4Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerMKuDFJ6iNipBDIL8oq2tMXGyipP4q5CwMWE976SbZCIMeta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesnyEXdxx7xHAE9_45dyfgqPZiubAIvfU5NX7951iTuoZe0Meta || {},
    component: () => import("/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/user/settings",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/statistiques",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  },
  {
    name: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubm2HGWdKu0050E6g8Bpzj4ZMNlM1z08wVJmCBSj6zaGI
  }
]